import EventBusyIcon from '@mui/icons-material/EventBusy'
import { Box, Button, Paper, Typography } from '@mui/material'
import * as React from 'react'

/**
 * EmptyStateCard component displays a message when there are no items to show
 * @param {Object} props
 * @param {string} props.title - Main message to display
 * @param {string} props.subtitle - Secondary message to display
 * @param {string} props.buttonText - Text for the action button
 * @param {function} props.onButtonClick - Click handler for the action button
 * @param {string} props.image - URL of the image to display
 * @param {boolean} props.showButton - Whether to show the action button
 * @param {Object} props.sx - Additional styles to apply
 */
export default function EmptyStateCard({ title, subtitle, buttonText, onButtonClick, image, showButton = false, sx = {} }) {
  return (
    <Paper
      sx={{
        p: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        minHeight: 200,
        ...sx,
      }}
    >
      {image ? (
        <Box
          component="img"
          src={image}
          alt={title}
          sx={{
            width: '100%',
            height: 140,
            objectFit: 'cover',
            borderRadius: 1,
            mb: 2,
          }}
        />
      ) : (
        <EventBusyIcon sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
      )}
      <Typography variant="h6" color="text.primary" gutterBottom>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {subtitle}
        </Typography>
      )}
      {showButton && buttonText && onButtonClick && (
        <Button variant="outlined" color="primary" onClick={onButtonClick}>
          {buttonText}
        </Button>
      )}
    </Paper>
  )
}
